import { createSlice } from "@reduxjs/toolkit";

export const emptyUserState = {
  fullName: "",
  nameid: "",
  email: "",
  role: "",  
  entity:"",
};

export const userAuthSlice = createSlice({
  name: "userAuthSlice",
  initialState:emptyUserState,
  reducers: {
    setLoggedInUser: (state, action) => {
      state.fullName = action.payload.fullName;
      state.nameid= action.payload.nameid;
      state.email=action.payload.email;
      state.role = action.payload.role;
      state.entity = action.payload.entity;
      
    },
  },
});

export const { setLoggedInUser } = userAuthSlice.actions;
export const userAuthReducer = userAuthSlice.reducer;